"use client";

import Link from "next/link";
import type { Id } from "@convex/_generated/dataModel";
import { Pencil } from "@/components/icons";
import { Button } from "@/components/ui/button";
import Container from "@/components/ui/container";
import { Badge } from "@/components/ui/badge";
import {
  adminListingHref,
  useCanEditListingsInAdmin,
} from "./use-listing-admin-access";

export function ListingStaffBar({
  productId,
  publicIdentifier,
}: {
  productId: Id<"products">;
  publicIdentifier?: string;
}) {
  if (!useCanEditListingsInAdmin()) return null;

  return (
    <div className="border-b border-border bg-surface-2">
      <Container className="flex items-center justify-between gap-3 py-2 text-sm">
        <p className="flex min-w-0 items-center gap-2 text-muted-foreground">
          <Badge variant="violet" weight="medium">
            Staff
          </Badge>
          <span className="truncate">{publicIdentifier ?? "Listing"}</span>
        </p>
        <Button variant="ink" size="sm" asChild className="shrink-0 gap-1.5">
          <Link href={adminListingHref(productId)}>
            <Pencil className="size-3.5" aria-hidden="true" />
            Edit in admin
          </Link>
        </Button>
      </Container>
    </div>
  );
}
